
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightFlashlightColourOff as ObiLightFlashlightColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-flashlight-colour-off.js';
 
 
 

 
 export const ObiLightFlashlightColourOff = createComponent({
   react: React,
   tagName: 'obi-light-flashlight-colour-off',
   elementClass: ObiLightFlashlightColourOffElement,
   events: {
     
   }
  });
 
 